export const webDocAuthBaseUrl = process.env.REACT_APP_AUTH_URL;
export const webDocApiBaseUrl = process.env.REACT_APP_API_URL;
export const swishCallbackUrl =
    'https://us-central1-ehealth-v2.cloudfunctions.net/app/api/webhook/swish/paymentrequest';
